"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Main_1 = __importDefault(require("../components/Main"));
function NotFound() {
    var location = (0, react_router_dom_1.useLocation)();
    return (react_1.default.createElement(Main_1.default, null,
        react_1.default.createElement("article", { className: "post", id: "index" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", null,
                    "Whoops! There's nothing to be found at",
                    react_1.default.createElement("code", null, location.pathname))))));
}
exports.default = NotFound;
